import NextImage, { ImageProps } from 'next/image';

const loader = (props: { src: string }) => props.src;

const Image = (props: ImageProps) => (
	<NextImage {...props} loader={loader} unoptimized />
);

export default Image;
